import { enableProdMode, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { AppModule } from './app/app.module';
import { AppService } from './app/core/services/app.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule, {
    applicationProviders: [
      { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
      provideZoneChangeDetection(),
      provideNativeDateAdapter(),
      provideNativeDateAdapter(),
      provideAppInitializer(() => {
        const appService = inject(AppService);
        return appService.initApp();
      })
    ],
  })
    .catch(err => console.error(err));
};


if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}

